import React from 'react'
import PT from 'prop-types'
import CountUp from 'react-countup'

const StatCountUp = ({ color='#30bc9d', data = 0, isMobile, prefix, suffix, alignment='text-center' }) => (
  <div style={{padding: isMobile ? 5 : 0}}>
    <div
      style={{
        borderRadius: '0.25rem',
        padding: isMobile ? 0 : 5,
      }}
    >
      <div className={`mb-0 ${alignment}`} >
        <CountUp
          prefix={prefix}
          separator=","
          start={0}
          end={data}
          style={{fontSize: isMobile ? 20 : 40, fontWeight: isMobile ? 400 : 600, color }}
          suffix={suffix}
        />
      </div>
    </div>
  </div>
)

StatCountUp.propTypes = {
  color: PT.string,
  data: PT.number,
  isMobile: PT.bool,
  style: PT.object,
  prefix: PT.string
}

export default StatCountUp



// WEBPACK FOOTER //
// ./src/components/ui/StatCountUp.js